import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as LogoIcon } from '../../assets/icons/epicplay_logo.svg';

export default React.memo(function Logo({logoClassName, className}) {
  return (
    <NavLink to={'/'}  className={`w-full ${className}`} >
      <LogoIcon className={`${logoClassName}`} fill='currentColor'/>
    </NavLink>
  );
})
